export default "__VITE_ASSET__D59QYVta__"